import { render, staticRenderFns } from "./UserProfileInvoiceDialog.vue?vue&type=template&id=1ddd1932&"
import script from "./UserProfileInvoiceDialog.vue?vue&type=script&lang=ts&"
export * from "./UserProfileInvoiceDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports